import React from "react";
import styled from "styled-components";

const Navigation = (props) => {
  const { data, active } = props;
  return (
    <Wrapper>
      {data.map((item, i) => {
        return (
          <StyledLi key={item.id} isActive={active === i}>
            {item.id}
          </StyledLi>
        );
      })}
    </Wrapper>
  );
};

export default Navigation;

const Wrapper = styled.ul`
  display: flex;
  justify-content: space-between;
  align-self: center;
`;

const StyledLi = styled.li`
  ${(props) => props.theme.fonts.p}
  color: ${(props) =>
    props.isActive ? props.theme.colors.text : props.theme.colors.link};
  white-space: nowrap;
  list-style-type: none;
`;
